import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import CardDsfrContext from "components/CardDsfrContext";
import SiteContext from "components/SiteContext";
import news from "components/templates/news/news";
import CardVertical from "components/templatesComponents/CardVertical";
import { useFindPagesByTemplateKeys } from "hooks/page.hook";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import t from "utils/locales/translation.json";

const LastNewsBlock = (props) => {
  const { highlightedNews = {}, lang } = props;

  const site = useContext(SiteContext);
  const { isHorizontal } = useContext(CardDsfrContext);

  const { name: siteName } = site || {};

  const hasHighlightedNews = useMemo(
    () => Boolean(highlightedNews?.props?.cards?.props?.page?.id || highlightedNews?.props?.children),
    [highlightedNews],
  );

  const filters = useMemo(() => {
    const newFilters = [`page.lang||eq||${lang}`];
    if (highlightedNews?.props?.cards?.props?.page?.id) {
      newFilters.push(`id||ne||${highlightedNews.props?.cards?.props?.page?.id}`);
    }
    return newFilters;
  }, [highlightedNews, lang]);

  const { data, isFetching } = useFindPagesByTemplateKeys({
    templates: [news.key],
    siteName,
    filters,
    perPage: !isHorizontal && hasHighlightedNews ? 2 : 3,
  });

  const newsPages = useMemo(() => data?.pages || data, [data]);

  if (!data && !isFetching) {
    return null;
  }

  return (
    <Grid container rowSpacing={5} columnSpacing={3} sx={{ mt: 0 }} component="ul" className="fr-raw-list">
      {Array.isArray(newsPages) && newsPages.length > 0 ? (
        <>
          {hasHighlightedNews && (
            <Grid key={highlightedNews.id} component="li" size={{ xs: 12, md: isHorizontal ? 12 : 4 }}>
              {highlightedNews}
            </Grid>
          )}
          {newsPages.map((p) => (
            <Grid key={p.id} component="li" size={{ xs: 12, md: 4 }}>
              <CardVertical page={p} />
            </Grid>
          ))}
        </>
      ) : (
        <Grid container sx={{ justifyContent: "center", mt: 3 }}>
          {isFetching ? <CircularProgress /> : <h2>{t[lang].common.news.no_result}</h2>}
        </Grid>
      )}
    </Grid>
  );
};

LastNewsBlock.propTypes = {
  highlightedNews: PropTypes.shape().isRequired,
  lang: PropTypes.string.isRequired,
};

export default LastNewsBlock;
